import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import {MenuComponent} from "@/assets/ts/components";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import ApiService from "@/core/services/ApiService";
import {ElMessage} from 'element-plus';
import Digram from "./components/BarLineDigram.vue";
import Filter from "./components/CategoryFilter.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const apiUrl = 'report/category';
const filters = reactive({
});
const indicator = ref<any[]>([]);
const showIndicator = reactive({
  'gmv': '销售额',
  'c_imp_onsale_goods_num': '均款曝光',
  'c_click_imp_rate': '曝光点击率',
  'end_onsale_goods_num': '在架款数',
});
const chartData = ref<any[]>([]);
const loading = ref<boolean>(false);

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("report.product.categoryChange", ["report.product.name", "report.product.categoryName"]);

  // 类目异动分析的指标要求用类目概览同期对比的表头指标
  ApiService.get('report/category/indicator', {report_id: 1}).then(({data}) => {
    if (data.length < 1) {
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      indicator.value = [];
      for (let i of data) {
        if (i.is_display == 1 && i.data_type != 1) {
          indicator.value.push(i);
        }
      }
    }
  });
});

// 搜索动作
const searchAction = (filter) => {
  for (let k in filter) {
    filters[k] = JSON.parse(JSON.stringify(filter[k]));
  }
  filters['category'] = filters['category'] ? filters['category'] : [];
  ApiService.get(apiUrl + '/change/?dimension=cat_name', filters).then(({data}) => {
    chartData.value = data;
    loading.value = true;
    setTimeout(() => {
      loading.value = false;
    }, 500);
  });
}

// 图形下钻，点击图形后，得到点击的类目名称
const drillDown = (data) => {
  if (filters['category'].length > 9) filters['category'].pop();  // 防止无限级下钻
  if (filters['category'][filters['category'].length - 1] !== data) filters['category'].push(data);  // 同级都是叶子节点会有问题
  ApiService.get(apiUrl + '/change/?dimension=cat_name', filters).then(({data}) => {
    chartData.value = data;
    loading.value = true;
    setTimeout(() => {
      loading.value = false;
    }, 500);
  });
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Filter, { onSearchAction: searchAction }),
    _withDirectives((_openBlock(), _createBlock(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showIndicator), (v, i) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            key: i,
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(Digram, {
                field: i,
                data: chartData.value,
                fields: indicator.value,
                onDrillDown: drillDown
              }, null, 8, ["field", "data", "fields"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })), [
      [_directive_loading, loading.value]
    ])
  ], 64))
}
}

})